import React from 'react';
import PropTypes from 'prop-types';
import { FormTextarea, ProfilePicture } from '@getro/rombo';
import { Box, Flex, Text } from 'rebass/styled-components';
import { X } from 'lucide-react';

export const RequestIntroReason = ({ people, handleReasonChange, removePerson, user }) => (
  <Flex sx={{ flexDirection: 'column', gap: '16px' }}>
    <Text fontWeight="semibold" fontSize="16px">
      {user ? '' : 'Step 1:'} Optionally add a reason why you&apos;d like to connect
    </Text>
    <Flex sx={{ flexDirection: 'column', gap: '16px' }}>
      {people.map((person) => (
        <Flex key={person.id} sx={{ position: 'relative', flexDirection: 'column', gap: '16px', width: '100%' }}>
          <Box flexShrink={0} sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Box sx={{ flexShrink: 0 }}>
              <ProfilePicture width="36px" height="36px" name={person.fullName} imageUrl={person.profilePicUrl} />
            </Box>
            <Flex sx={{ alignItems: 'center', gap: '8px', justifyContent: 'space-between', width: '100%' }}>
              <Box>
                <Text fontWeight="500" color="text.dark" fontSize="14px" lineHeight="16px">
                  {person.fullName}
                </Text>
                <Text color="text.main" fontSize="14px">
                  {person.linkedinTagline}
                </Text>
              </Box>
              {people.length > 1 && (
                <Box
                  as={X}
                  size="16px"
                  sx={{ color: 'neutral.400', cursor: 'pointer' }}
                  onClick={() => removePerson(person.id)}
                />
              )}
            </Flex>
          </Box>
          <FormTextarea
            value={person.reason}
            onChange={(e) => handleReasonChange(person.id, e.target.value)}
            placeholder="Share why you want this intro"
            sx={{ maxHeight: '64px', width: '100%' }}
          />
        </Flex>
      ))}
    </Flex>
  </Flex>
);

RequestIntroReason.propTypes = {
  people: PropTypes.array.isRequired,
  handleReasonChange: PropTypes.func.isRequired,
  removePerson: PropTypes.func.isRequired,
  user: PropTypes.bool.isRequired,
};
